import { AlertCircle, X } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';

interface AuthErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string | null;
}

export function AuthErrorModal({ isOpen, onClose, message }: AuthErrorModalProps) {
  return (
    <AnimatePresence>
      {isOpen && message && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-zinc-900/60 backdrop-blur-sm"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="relative w-full max-w-sm bg-white dark:bg-zinc-900 p-8 rounded-[32px] shadow-2xl border border-zinc-100 dark:border-zinc-800 text-center space-y-6 transition-colors"
          >
            <button 
              onClick={onClose}
              className="absolute top-4 right-4 p-2 hover:bg-zinc-100 dark:hover:bg-zinc-800 rounded-full transition-colors"
            >
              <X className="w-5 h-5 text-zinc-400" />
            </button>
            <div className="w-16 h-16 bg-rose-50 dark:bg-rose-900/20 rounded-2xl flex items-center justify-center mx-auto">
              <AlertCircle className="text-rose-500 w-8 h-8" />
            </div>
            <div className="space-y-2">
              <h2 className="text-xl font-bold text-zinc-900 dark:text-zinc-100">Login Issue</h2>
              <p className="text-sm text-zinc-500 dark:text-zinc-400 leading-relaxed">
                {message}
              </p>
            </div>
            <button
              onClick={onClose}
              className="w-full py-4 bg-zinc-900 dark:bg-zinc-100 text-white dark:text-zinc-900 rounded-2xl font-bold shadow-lg active:scale-95 transition-transform"
            >
              Got it
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}